// EMBERS — core domain types
// All data here is captured with explicit, granular, revocable consent.

export type ForkChoice =
  | 'withdraw_protect'      // I pulled back / blocked / stopped offering energy
  | 'name_repair'           // I named the impact and asked for / offered repair
  | 'contextual_grace'      // I offered a more generous re-reading and let it go / moved on
  | 'enforce_boundary'      // I stated a limit and accepted the relationship / dynamic as it now is

export const FORK_LABELS: Record<ForkChoice, string> = {
  withdraw_protect: 'Withdraw / Protect energy',
  name_repair: 'Name impact + seek repair',
  contextual_grace: 'Offer contextual grace',
  enforce_boundary: 'Enforce a boundary',
}

export const FORK_SHORT: Record<ForkChoice, string> = {
  withdraw_protect: 'withdraw',
  name_repair: 'repair',
  contextual_grace: 'grace',
  enforce_boundary: 'boundary',
}

export interface Reflection {
  id: string
  friction_text: string
  cooperation_threshold: number
  cooperation_note: string
  reciprocity_offered: string
  reciprocity_received: string
  reciprocity_imbalance_note: string
  fork_choice: ForkChoice
  fork_note: string
  norm_named: string
  ai_spark?: string | null
  share_to_coals: number
  allow_ai: number
  telemetry_consent: number
  artifact_r2_key?: string | null
  created_at: string

  // Populated only for the owner
  resonances?: Resonance[]
}

export interface PublicEmber {
  // What is shown in the shared "Coals" (never includes raw friction_text or user id)
  id: string
  cooperation_threshold: number
  fork_choice: ForkChoice
  norm_named: string
  shared_context: string   // user-provided short version for the commons
  created_at: string
  resonance_count: number
}

export interface Resonance {
  id: string
  body: string
  created_at: string
}

export interface ValuesFingerprintParams {
  cooperation: number        // 0–1
  fork: ForkChoice
  reciprocityBalance: number // -1 (I gave much more) … +1 (I received much more) — derived or direct
  normWeight: number         // how much this norm matters to the person right now (0–1)
  normText: string
}

export interface SparkRequest {
  reflectionId?: string
  cooperation: number
  fork: ForkChoice
  reciprocityOffered: string
  reciprocityReceived: string
  normNamed: string
  shortContext?: string
}

export interface EmberSeed {
  seed: string
  hash: string
  userId?: string
}
